"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPromotionsForCampaign = exports.getPromotions = void 0;
var _utils = require("../utils");
var _paramKeys = _interopRequireDefault(require("./paramKeys"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

// We must use a client with no parameters in order to have required/optional match the API spec

// This is defined here, rather than `types.ts`, because it relies on `Client` and `QueryKeys`,
// and making those generic would add too much complexity.

const getPromotions = exports.getPromotions = {
  path: params => ['/commerce-sdk-react', '/organizations/', params.organizationId, '/promotions'],
  queryKey: params => {
    const paramKeys = [..._paramKeys.default['getPromotions'], ...(0, _utils.getCustomKeys)(params)];
    return [...getPromotions.path(params), (0, _utils.pick)(params, paramKeys)];
  }
};
const getPromotionsForCampaign = exports.getPromotionsForCampaign = {
  path: params => ['/commerce-sdk-react', '/organizations/', params.organizationId, '/promotions/campaigns/', params.campaignId],
  queryKey: params => {
    const paramKeys = [..._paramKeys.default['getPromotionsForCampaign'], ...(0, _utils.getCustomKeys)(params)];
    return [...getPromotionsForCampaign.path(params), (0, _utils.pick)(params, paramKeys)];
  }
};